import { Client } from "@/protocols/clientCatalog"
import { BaseContactsFiltersType } from "@/protocols/ClientCatalogFilterProtocol"
import ApiService from "@/services/Api"

class ClientCatalogContactService {
	async disableContactsByFilter (filterConditions?: BaseContactsFiltersType) {
		await ApiService.put("/contacts/disable-contacts", {
			contactFilters: filterConditions
		})
	}

	async disableContact (client?: Client) {
		await ApiService.put("/contacts/disable-contact", {
			client
		})
	}
}

export default new ClientCatalogContactService()
